// extracted by mini-css-extract-plugin
export var divider = "_jq-7";
export var itemsToggle = "_jq-8";
export var mergeModal = "_jq-1";
export var optionCard = "_jq-4";
export var radioGroup = "_jq-6";
export var radioOption = "_jq-0";
export var selected = "_jq-5";
export var shipmentOptions = "_jq-2";
export var tableOptions = "_jq-3";